import React from "react";
import {
  Button,
  Text,
  Flex,
  Image,
  ModalContent,
  ModalOverlay,
  Modal,
  Box,
  Td,
  Tbody,
  Tr,
  Thead,
  Table,
  TableContainer,
} from "@chakra-ui/react";
import { DownloadIcon } from "@chakra-ui/icons";
import iconClose from "../../assets/images/projectManagement/x-circle.svg";
import iconFile from "../../assets/images/projectManagement/file-text.svg";

const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const FileDownload = ({ isOpen, onClose, onDownLoad, files }) => {
  // console.log(files);
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        borderRadius={"16px"}
        maxW={"625px"}
        maxH={"800px"}
        overflow="auto"
      >
        <Flex
          borderBottom={"1px solid var(--color-boder)"}
          alignItems={"center"}
          justifyContent={"space-between"}
          p={"24px 20px 24px 24px"}
        >
          <Text fontSize={"18px"} fontWeight={600} lineHeight={"normal"}>
            Tài liệu
          </Text>
          <Image src={iconClose} onClick={onClose} cursor={"pointer"} />
        </Flex>
        <Box p={"24px"} backgroundColor={"var(--color-backgroundmain)"}>
          <Box
            flex={1}
            // w={"545px"}
            backgroundColor={"var(--color-main)"}
            borderRadius={"16px"}
            p={"16px 0"}
          >
            <TableContainer w={"100%"}>
              <Table
                w={"100%"}
                variant="unstyled"
                // border={"1px solid var(--color-boder)"}
              >
                <Thead
                  w={"100%"}
                  h={"41px"}
                  fontWeight="400"
                  borderBottom={"1px solid var(--color-boder)"}
                  bg={"var(--color-main)"}
                >
                  <Tr h={{ base: "41px" }}>
                    <Td
                      p={"16px 16px 12px 16px"}
                      border={"none"}
                      color={"#51607B"}
                      fontSize={{ base: "14px" }}
                    >
                      Tên file
                    </Td>
                    <Td
                      p={"16px 16px 12px 16px"}
                      border={"none"}
                      color={"#51607B"}
                      fontSize={{ base: "14px" }}
                    >
                      Tải xuống
                    </Td>
                  </Tr>
                </Thead>
                <Tbody w={"100%"} h={"100%"}>
                  {files.map((item, index) => (
                    <Tr
                      w={"100%"}
                      h={"42px"}
                      backgroundColor={
                        index % 2 === 0
                          ? "var(--color-main)"
                          : "var(--fill-avatar)"
                      }
                    >
                      <Td
                        p={"16px 16px 8px 16px"}
                        w={"80%"}
                        verticalAlign={"center"}
                      >
                        <Flex gap={"4px"} alignItems={"center"}>
                          <Image src={iconFile} />
                          {item?.name
                            ? item?.name
                            : item?.file || "Đây là tên tài liệu của dự án"}
                        </Flex>
                      </Td>
                      <Td
                        p={"16px 16px 8px 16px"}
                        w={"20%"}
                        textAlign={"center"}
                        verticalAlign={"center"}
                      >
                        <Button
                          bg={"none"}
                          leftIcon={
                            <DownloadIcon color={"var(--color-secondary)"} />
                          }
                          colorScheme="teal"
                          onClick={() =>
                            onDownLoad(
                              item?.path ? `${baseURL}/${item?.path}` : ""
                            )
                          }
                          _hover={{
                            filter: "brightness(90%)",
                          }}
                          p={"0px"}
                          w={"max-content"}
                          position={"relative"}
                        ></Button>
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default FileDownload;
